import React from 'react'
import { FilterName, FilterParam } from '../FilterBar.types'
import { GenericFilterDropdown } from './GenericFilterDropdown'

export const CompanyFilterDropdown = React.memo(
  ({ isNested = false }: { isNested?: boolean }): JSX.Element => {
    return (
      <GenericFilterDropdown
        filterParam={FilterParam.COMPANY}
        filterName={FilterName.COMPANY}
        valueKey="companies"
        isNested={isNested}
      />
    )
  },
)
